import { SOUND_COUNTER_KEYS, type SoundCounters } from '../../../relay/src/diagnostics/browserSample';

let enabled = false;
let counters = empty();
function empty(): SoundCounters {
  return Object.fromEntries(SOUND_COUNTER_KEYS.map(key => [key, 0])) as SoundCounters;
}
/** Only runs during the existing opt-in capture. No timer, I/O or subscriber. */
export function recordSoundDecision(key: keyof SoundCounters): void {
  if (enabled) counters[key] = Math.min(1_000_000, counters[key] + 1);
}
export function resetSoundDiagnostics(active = false): void {
  enabled = active;
  counters = empty();
}
export function soundDiagnosticsSnapshot(): SoundCounters { return { ...counters }; }
